<template lang="pug">
md-table-card.card
  info-series-dialog(ref="infoSeriesDialog")
  form(novalidate='', @submit.stop.prevent='search')
    .filters
      md-layout.search(md-align='end')
        md-layout.searchContainer(md-flex='33', md-align='end')
          md-layout
            md-input-container
              label Search
              md-input(v-model.lazy='searchText',  v-on:keypress.enter="search()" )
          md-layout(md-flex='15', v-if='searchText != ""')
            md-button.clean-search-label-btn.md-icon-button.btn(@click='cleanSearchText')
              md-icon.icon(md-iconset="fa fa-trash-alt")
          md-layout(md-flex='10')
            md-button.md-icon-button.btn(type='submit', :disabled='loading')
              md-icon.icon(md-iconset="fa fa-search")

  stitch-loader(v-if='loading', :loading='loading', :size='45')
  div(v-if='hasSeriesToDisplay')
    div.titleLine.styleRow
      p.rowElements.sortable(@click = "onSort('name')") Name {{sort.name === 'name' ? sort.type === 'desc' ? '&darr;' : '&uarr;' : ''}}
      p.rowElements Status
      p.rowElements.sortable(@click = "onSort('lastUpdated')") Updated {{sort.name === 'lastUpdated' ? sort.type === 'desc' ? '&darr;' : '&uarr;' : ''}}
      p.rowElements
    div.styleRow.colorHover(v-for='serie in series', :key='serie._id')
      div.rowElements {{serie.name}}
      div.rowElements(v-if="serie.status === 'public'") live
      div.rowElements(v-else) {{ serie.status }}
      div.rowElements {{ serie.lastUpdated | moment('from') }}
      div.rowElements.iconsContainer
        md-button#info-series.md-icon-button.md-raised.btn(@click='infoSeries(serie._id, serie.name)')
          md-icon.icon(md-iconset="fa fa-list")
        md-button#edit-series.md-icon-button.md-raised.btn(@click='editSerie(serie._id)')
          md-icon.icon(md-iconset="fa fa-pencil-alt")
        md-button#delete-series.md-icon-button.md-raised.btn(@click='deleteSerie(serie._id, serie.name)')
          md-icon.icon(md-iconset="fa fa-trash-alt")

  md-table-pagination(
    v-show='hasSeriesToDisplay',
    :md-size='currentPagination.size',
    :md-total='totalSeries',
    :md-page='currentPagination.page',
    md-label='Series',
    md-separator='of',
    :md-page-options='[10, 25, 50, 100]',
    @pagination='onPageChanged'
  )

  div#no-results(v-if='hasNoResults')
      md-icon.md-accent(md-iconset="fa fa-exclamation-circle",)
      | No items to show
</template>

<script>
import serieService from '../../services/serieService';
import stitchLoader from '../../shared-components/Loader';
import InfoSeriesDialog from './InfoSeriesDialog.vue';

export default {
  components: {
    stitchLoader,
    InfoSeriesDialog
  },
  data() {
    return {
      series: [],
      totalSeries: null,
      loading: false,
      currentPagination: {
        page: 1,
        size: 10
      },
      sort: {
        name: 'lastUpdated',
        type: 'desc'
      },
      searchText: ''
    };
  },
  computed: {
    searchParams() {
      const params = {
        offset: (this.searchText || this.currentPagination.page == 1) ? 0 : this.currentPagination.size * (this.currentPagination.page - 1),
        limit: this.$session.get("limitPaginationSeries") || this.currentPagination.size,
        sortBy: this.sort.name,
        sortOrder: this.sort.type
      };
      if (this.searchText) {
        Object.assign(params, { name: this.searchText });
      }
      // This check is to prevent the offset isn't larger than the total items.
      if (this.totalSeries != null && params.offset >= this.totalSeries) {
        params.offset = 0
      }

      return params;
    },
    hasSeriesToDisplay() {
      return !this.loading && this.series.length > 0;
    },
    hasNoResults() {
      return !this.loading && this.series.length === 0;
    }
  },
  methods: {
    showAlertToast(text, icon) {
      this.$swal({
        text: text,
        position: 'bottom-left',
        icon: icon,
        toast: true,
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false,
      }
      )
    },
    onPageChanged(paginationParams) {
      this.currentPagination = paginationParams;
      this.$session.set("iWasInPageSeries", paginationParams.page);
      this.$session.set("limitPaginationSeries", paginationParams.size);
      this.search();
    },

    onSort(sortParams) {
      this.sort.name = sortParams;
      this.sort.type = this.sort.type === 'desc' ? 'asc' : 'desc';
      this.search();
    },

    search() {
      this.loading = true;
      serieService.getList(this.searchParams)
        .then((response) => {
          this.series = response.data.series;
          this.totalSeries = response.data.total;
        })
        .catch((error) => {
          console.error('Error while retrieving the list of networks', error);
        })
        .then(() => {
          this.loading = false;
        });
    },
    infoSeries(seriesId, seriesName) {
      this.$refs.infoSeriesDialog.openDialog(seriesId, seriesName)
    },

    editSerie(serieId) {
      this.$router.push({
        name: 'EditSerie',
        params: {
          id: serieId
        }
      });
    },

    deleteSerie(serieId, serieName) {
      this.$swal.fire({
        title: 'Delete',
        text: `${serieName}?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete',
        cancelButtonText: 'No',
      }).then((res) => {
        if (res.isConfirmed) {
          this.loading = true;
          serieService.delete(serieId).then(() => {
            this.search();
          })
            .catch(() => {
              this.showAlertToast('Series could not be deleted. Please, try again later', 'error');
            })
            .then(() => {
              this.loading = false;
            })
          this.showAlertToast('Series deleted successfully', 'success');
        }
      })
    },

    cleanSearchText() {
      this.searchText = '';
      this.search()
    },
  },

  mounted() {
    if (this.$session.get("iWasInPageSeries") === undefined) {
      this.$session.set("iWasInPageSeries", 1);
    }
    this.currentPagination.page = this.$session.get('iWasInPageSeries');
    if (this.$session.get("limitPaginationSeries") !== undefined) {
      this.currentPagination.size = this.$session.get("limitPaginationSeries");
    }
    this.$session.set("iWasInPage", 1);
    this.$session.set("iWasInPageNetworks", 1);
    this.$session.set("iWasInPagePlaylist", 1);
    this.$session.set("iWasInPageUserActivity", 1);
    this.$session.set("iWasInPageChannel", 1);
    this.$session.set("iWasInPageDistributions", 1);
    this.$session.set("iWasInPageDomains", 1);
    this.$session.set("iWasInPageLicences", 1);
    this.$session.set("iWasInPageVideoSources", 1);
    this.search();
  },
  watch: {
    currentPagination(newValue, oldValue) {
      if (newValue.size !== oldValue.size) {
        this.currentPagination.page = 1
        this.search()
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  padding: 10px;
  width: 80vw;
  margin: auto !important;
  margin-top: 20px !important;
  border-radius: 10px;
  box-shadow: 1px 1px 20px 5px rgba(0, 0, 0, 0.2);
}

.search {
  margin-right: 10px;

  @media (max-width: 1200px) {
    margin-right: 20px;
  }
}

.searchContainer {
  flex: none;
}

.filters {
  padding: 2px 20px;
}

.md-table {

  .md-sortable.md-sorted,
  .md-sortable:hover {
    color: #0198cf;
  }
}

#no-results {
  margin: auto;
  padding: 20px;

  .md-icon {
    margin-right: 5px;
  }
}

.serie-actions {
  display: flex;
  justify-content: center;
  width: 100%;
}

.styleRow p {
  font-weight: 600;
}

.rowElements {
  flex: 1;
  padding: 6px 32px 6px 24px;
}

.colorHover:hover {
  background-color: #eee;
}


.titleLine {
  padding: 0px;
  border-bottom: 1 px solid rgba(153, 155, 155, 0.486);
}

.sortable:hover {
  cursor: pointer;
  color: #4ea9dd;
}

.iconsContainer {
  display: flex;
  justify-content: center;
}</style>



// WEBPACK FOOTER //
// src/shared-components/serie/SerieTable.vue